const ShipmentIcon = ({
  color,
  width=32, 
  height=32,
  uniqueId,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M21.3335 9.33337H10.6668C10.0002 9.33337 9.3335 9.93337 9.3335 10.6667V12.6734C9.3335 13.1534 9.62016 13.5667 10.0002 13.8V21.3334C10.0002 22.0667 10.7335 22.6667 11.3335 22.6667H20.6668C21.2668 22.6667 22.0002 22.0667 22.0002 21.3334V13.8C22.3802 13.5667 22.6668 13.1534 22.6668 12.6734V10.6667C22.6668 9.93337 22.0002 9.33337 21.3335 9.33337ZM17.3335 17.3334H14.6668C14.3002 17.3334 14.0002 17.0334 14.0002 16.6667C14.0002 16.3 14.3002 16 14.6668 16H17.3335C17.7002 16 18.0002 16.3 18.0002 16.6667C18.0002 17.0334 17.7002 17.3334 17.3335 17.3334ZM21.3335 12.6667H10.6668V10.6667H21.3335V12.6667Z" fill={color}/>
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1}/>
          <stop offset="0.885417" stopColor={radiosColor2}/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShipmentIcon;
